module.exports = __webpack_public_path__ + "static/favicons/apple-touch-icon-76x76-2a91ddefe27ee0d55351c1f6cbe237f9.png";